


























































import mixins from 'vue-typed-mixins';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import { ChalkingTimeZone } from './ChalkingTimeZone';
import VatsAPI from '@/Shared/VatsAPI';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { Dictionary } from 'vue-router/types/router';
import BuildEntityListComponent from '@/Shared/CommonEntityMixins/EntityListComponentMixin';

const component = mixins(LocationBasedMixin, BuildEntityListComponent<ChalkingTimeZone>()).extend({
    data() {
        return {
            i18nPrefix: 'admin.programVariables.handhelds.chalkingTimeZones',
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/HandheldAdmin/ChalkingTimeZones`;
        }
    },
});

export default component;
